export interface User {
  id?: number;
  firstName: string;
  lastName: string;
  email: string;
  company: string;
  lastLogin: Date | null;
  password?: string;
  role: number;
  isActive: boolean;
  creationDate?: Date;
  departmentId?: number;
}

// === DATI STATICI ===
export const DEPARTMENTS = [
  { id: 1, name: "Commerciale & Vendite" },
  { id: 2, name: "Partnership & Supplier Management" },
  { id: 3, name: "Operations / Ticketing Operations" },
  { id: 4, name: "Customer Care / Support" },
  { id: 5, name: "IT & Technology" },
  { id: 6, name: "Product Management" },
  { id: 7, name: "Marketing & Growth" },
  { id: 8, name: "Finance & Amministrazione" },
  { id: 9, name: "Legal & Compliance" },
  { id: 10, name: "HR & People" },
  { id: 11, name: "Data & Business Intelligence" },
];

export const ROLES: { [key: number]: string } = {
    1: "Amministratore",
    2: "Responsabile",
    3: "Utente",
    4: "Viewer",
};
